import { Component, OnInit, inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Store } from "@ngrx/store";

import { ActionToastrWarning } from "@app/core/toastr/toastr.reducer";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "ddd-edit-dialog",
  templateUrl: "./edit-dialog.component.html",
  styleUrls: ["./edit-dialog.component.scss"],
  standalone: true,
  imports: [FormsModule]
})
export class EditDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<EditDialogComponent>>(MatDialogRef);
  private readonly store = inject<Store<any>>(Store);
  data = inject(MAT_DIALOG_DATA);

  public dialog: any;
  public originalName: string;

  constructor() {
    const data = this.data;

    this.originalName = data.name;
  }

  ngOnInit() {
    return;
  }
  onSubmit() {
    if (this.data.existingNames && this.checkItemName(this.data.name)) {
      this.store.dispatch(
        new ActionToastrWarning({
          message: "Section names cannot be the same."
        })
      );
      return false;
    }
    this.dialogRef.close(this.data.name);
  }

  public checkItemName(itemName) {
    if (itemName.toLowerCase() === this.originalName.toLowerCase()) {
      return false;
    }
    const items = this.data.existingNames.filter((name) => name.toLowerCase() === itemName.toLowerCase());
    return items && items.length !== 0 ? true : false;
  }
}
